import React from "react";
import useToggle from "hooks/useToggle";
import { ReactComponent as EyeView } from "svgs/eye-view.svg";
import { ReactComponent as EyeClose } from "svgs/eye-close.svg";
import Input from "components/input";
import clsx from "clsx/lite";

const PasswordInput = ({ value, name = "password", error, showError = true, hideLabel = false, ...other }) => {
	const [showPassword, togglePassword] = useToggle();

	return (
		<div className="relative">
			<Input
				{...other}
				type={showPassword ? "text" : "password"}
				name={name}
				minLength={5}
				id={name}
				required
				value={value}
				label={hideLabel ? "" : "Password"}
				autoComplete="current-password"
				error={error}
				showError={showError}
			/>
			<div
				className={
					clsx("absolute right-3 transform -translate-y-1/2 cursor-pointer",
						showError && error ? "top-[35%]" : "top-1/2")}
				onClick={togglePassword}
			>
				{value && (showPassword ? <EyeView /> : <EyeClose />)}
			</div>
		</div>
	);
};

export default PasswordInput;